module.exports = __webpack_public_path__ + "img/logo-m.e6e7c205.png";